angular.module('impactx.panel', []);